import React, { createContext, ReactNode, useState, useEffect } from 'react';
import { FlowyGlobal } from '../../flowy';
import { IPlatformInterface } from '../../types';
import { IDatabase } from '../../database';

interface IFlowyGlobalProvider {
  apiUrl: string;
  databasePath?: string;
  database?: IDatabase;
  platformInterface?: IPlatformInterface;
  loadingComponent: ReactNode;
  children: ReactNode[] | ReactNode;
}

export const FlowyGlobalContext = createContext<FlowyGlobal | undefined>(
  undefined
);

export function FlowyGlobalProvider({
  apiUrl,
  database,
  platformInterface,
  loadingComponent,
  children,
}: IFlowyGlobalProvider) {
  const [flowyGlobal, setFlowyGlobal] = useState<FlowyGlobal | undefined>();

  useEffect(() => {
    const f = new FlowyGlobal({ apiUrl, platformInterface, database });
    f.init().then((fg: FlowyGlobal) => {
      setFlowyGlobal(fg);
    });
  }, []);

  return (
    <FlowyGlobalContext.Provider value={flowyGlobal}>
      {flowyGlobal ? children : loadingComponent}
    </FlowyGlobalContext.Provider>
  );
}
